import { useEffect } from "react";
import { doc, getDoc } from "firebase/firestore";
import { db } from "@/firebase";
import { useI18nField } from "../../locale/LocaleContext";


function applyTags({ title, description, ogTitle, ogDescription, ogImage }) {
  if (title) document.title = title;

  const set = (selector, value) => {
    if (!value) return;
    let tag = document.querySelector(selector);
    if (!tag) {
      tag = document.createElement("meta");
      if (selector.includes('name="')) {
        tag.setAttribute("name", selector.match(/"([^"]+)"/)[1]);
      } else {
        tag.setAttribute("property", selector.match(/"([^"]+)"/)[1]);
      }
      document.head.appendChild(tag);
    }
    tag.setAttribute("content", value);
  };

  set('meta[name="description"]', description);
  set('meta[property="og:title"]', ogTitle || title);
  set('meta[property="og:description"]', ogDescription || description);
  if (ogImage) set('meta[property="og:image"]', ogImage);
}

export function useSubdeptPageMeta(deptId, subdeptId) {
  const f = useI18nField();

  useEffect(() => {
    if (!deptId || !subdeptId) return;

    async function load() {
      const ref = doc(db, "departments", deptId, "subdepartments", subdeptId);
      const snap = await getDoc(ref);
      if (!snap.exists()) return;

      const data = snap.data();

      const title = f(data, "metaTitle") || f(data, "name") || subdeptId;
      const description = f(data, "metaDescription") || "";
      const ogTitle = f(data, "metaOgTitle") || title;
      const ogDescription = f(data, "metaOgDescription") || description;
      const ogImage = data.metaOgImage || data.imageUrl || "";

      applyTags({
        title,
        description,
        ogTitle,
        ogDescription,
        ogImage,
      });
    }

    load();
  }, [deptId, subdeptId, f]);
}
